import { Component, OnInit } from '@angular/core';
import { LocalDataSource, ServerDataSource } from 'ng2-smart-table';
import { ApiService } from '../../shared/api.service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DatePipe } from '@angular/common';
import { UpdateArticleComponent } from './edit-article/update-article.component';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { ActivatedRoute, Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { Article } from '../../shared/data/article';
import { PublishRenderComponent } from '../projet/publish-render.component';

import swal from 'sweetalert2';

@Component({
  selector: 'ngx-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {

  // articles: Article[] = [];
 
  articleEdit: Article;

  param = "";

  titre = '';

  source: LocalDataSource =  new LocalDataSource();
  settings = {

    hideSubHeader: false,
   
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: false,
      
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
  columns: {
    id: {
      title: 'ID',
      type: 'number',
      filter: false,
    },
    urltmbPhoto: {
      title: 'Photo',
      type: 'html',
      valuePrepareFunction: (photo:string) => { return `<img  src="${photo}" height="50px" width="50px" />`; },
      filter: false
    },
    titre: {
      title: 'Titre',
      type: 'string',
    },
   /*  date_publish: {
      title: 'date de publication',
      type: 'string',
      filter: false,
    }, */
    is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    },

  },
  pager : {
                perPage :10
  },
 
};

  

  constructor(public route: ActivatedRoute, private datePipe: DatePipe,private eventSendeur: EventSendeurService, private apiService:ApiService,private dialogService: NbDialogService,private toastr: NbToastrService,private router:Router) {

    /* this.route.params.forEach(params => {
    
      this.param = params['type'];
  
          if (params['type'] === 'blog' || params['type'] === 'orientation' || params['type'] === 'mentoring')  {
  
            // this.getCurrentDay();
            // this.settingService.getCurrentDay();
            this.ngOnInit();
          }
  
    }); */

  }

  ngOnInit() {

    this. getArticles();

    switch(this.param) { 
      case 'blog': { 
         //statements; 
         this.titre = 'Blog';
         break; 
      } 
      case 'orientation': { 
         //statements; 
         this.titre = 'Orientation';
         break; 
      } 
      case 'mentoring': { 
        //statements; 
        this.titre = 'Mentoring';
        break; 
      } 
      default: { 
         //statements; 
         break; 
      } 
    }

    this.eventSendeur.article.asObservable().subscribe ( data => {

      if( data === null )
      return;

      /* if( data.editMode === 'update') {
        this.source.update( this.articleEdit, data);
      }

      if( data.editMode === 'create') {
        this.source.prepend(data);
      } */

      this.getArticles();

    })

    

    /* this.eventSendeur.article.subscribe(data =>{
    this. getArticles();
    },(err) =>{
      
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
      
    }) */
   
  }



  onDelete(event): void {
    /* this.articleEdit = event.data;
    this.dialogService.open(DeleteArticleComponent,{context: { id: event.data.id}}); */
    const art = plainToClass( Article,  event.data as object);
    
    swal({
      title: 'Suppression Article',
      text: 'Voulez - vous vraiment supprimer ' + art.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteArticleProvider(art.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Supprimé(e)", art.titre);

      }

      // this.dialogIsNotShow = false;


    });

  }

  onEditRowSelect($event){
    alert($event.id);
  }


  onCreate(event){

    this.articleEdit = undefined;;

    this.addArticle();

  }


  select(event){
    this.articleEdit = event.data;
    this.dialogService.open(UpdateArticleComponent,{context: { id: event.data.id}});
  }

  /* removeUser($event){
    this.dialogService.open(DeleteArticleComponent,{context: { id: $event.data.id}});
  } */

  getArticles(){
    this.apiService.getArticleProvider(this.param).subscribe(data =>{
     
      let arts: any; 
      arts = plainToClass( Article, data.result);
      this.source.load(arts);
     
      /* const tmps = data as any[];   
      this.articles = tmps.map(tmp => {
        return { 
          avatar: 'http://apishared.cotafric.net'+tmp.photo.url ,
          date: this.datePipe.transform(tmp.date_publish, 'yyyy-MM-dd'),
          titre: tmp.titre,   
          id:tmp.id,
          is_publish:tmp.is_publish
        };
   
      }); */

    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

  addArticle(){
    this.dialogService.open(UpdateArticleComponent,{context: { id: 0, type_art: this.param}});
  }

  onSaveConfirm($event) {
    alert("hello");
    this.dialogService.open(UpdateArticleComponent,{context: { id: $event.data.id}});
  }

}
